module.exports = __webpack_public_path__ + "static/media/doctor.6e0ecd78.png";